import { dayTimeEnum } from "utils/enums";
import { array, number, object, string } from "yup";

const CreateInteractionSchema = object({
  patient: number().required("required").min(0, "required"),
  practitioner: number().required("required").min(0, "required"),
  activities: array().of(number().required("required")).min(1, "required"),
  prescriptions: array()
    .of(
      object().shape({
        prescriptionId: number().required("required"),
        name: string(),
        numberOfTablets: number().required("required").min(1, "required"),
        lengthOfDays: number().required("required").min(1, "required"),
        timesOfUsage: array()
          .of(
            string().is(
              [dayTimeEnum.MORNING, dayTimeEnum.AFTERNOON, dayTimeEnum.NIGHT],
              "must be a valid time of day"
            )
          )
          .min(1, "must select atleast one time of day")
          .required("required"),
        note: string().trim(),
      })
    )
    .min(1, "required")
    .required("required"),
  prescriptionNumber: string().required("required"),
  additionalNotes: string().trim(),
});

export default CreateInteractionSchema;
